// extracted by mini-css-extract-plugin
export default {"root":"Details_root__BeSZP"};